import { render, staticRenderFns } from "./ViewMultipleFile.vue?vue&type=template&id=b0ba1170&scoped=true&"
import script from "./ViewMultipleFile.vue?vue&type=script&lang=js&"
export * from "./ViewMultipleFile.vue?vue&type=script&lang=js&"
import style0 from "./ViewMultipleFile.vue?vue&type=style&index=0&id=b0ba1170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ba1170",
  null
  
)

export default component.exports